module.exports = __webpack_public_path__ + "images/Popup_960x720_v24.png";